import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import {
    Col,
    Row,
} from 'reactstrap'

import CardDeck from '../devices/list/CardDeck'
import ActiveDevicesChart from './ActiveDevicesChart'
import DevicesMap from './DevicesMap'
import { readDevices } from '../devices/helpers'

interface Device {
    isMonitored?: boolean
    lastSeenStatus?: string
    oilAlarm?: boolean
}

interface DevicesState {
    devices: {
        data: Device[]
    }
}

const MapsIndex = () => {
    const devices = useSelector((state: DevicesState) => state.devices.data) ?? []
    const devicesCount = devices.filter(device => device.isMonitored).length
    const failureCount = devices.filter(device => device.lastSeenStatus !== 'ok' && device.isMonitored).length
    const oilAlarmCount = devices.filter(device => device.oilAlarm === true && device.isMonitored).length

    useEffect(() => {
        readDevices()
    }, [])

    return (
        <div className="container mt-5 mt-md-0">
            <CardDeck
                devicesCount={devicesCount}
                failureCount={failureCount}
                oilAlarmCount={oilAlarmCount}
            />
            <Row noGutters>
                <Col lg="4" className="pr-lg-2">
                    <ActiveDevicesChart />
                </Col>
                <Col lg="8" className="pl-lg-2">
                    <DevicesMap />
                </Col>
            </Row>
        </div>
    )
}

export default MapsIndex
